<div class="company-document-revisions table-responsive">
  <table class="table table-hover align-middle mb-0">
    <thead>
      <tr>
        <th>Revision</th>
        <th>Date</th>
        <th>Status</th>
        <th>Reviewer</th>
        <th>Approver</th>
        <th>Attachment</th>
        <th class="text-end">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (revision of revisions; track revision.companyDocumentRevisionId) {
        <tr>
          <td class="fw-semibold">{{ revision.code }}</td>
          <td>{{ formatDate(revision.date) }}</td>
          <td>
            <span class="badge" [class]="'badge ' + statusBadgeClass(revision)">{{ statusLabel(revision) }}</span>
          </td>
          <td>
            {{ reviewerLabel(revision) }}
            @if (revision.reviewedSigned) {
              <i class="fa fa-check text-success ms-1" title="Signed"></i>
            }
          </td>
          <td>
            {{ approverLabel(revision) }}
            @if (revision.approvedSigned) {
              <i class="fa fa-check text-success ms-1" title="Signed"></i>
            }
          </td>
          <td class="file-name" [title]="attachmentName(revision)">
            {{ attachmentName(revision) || '-' }}
          </td>
          <td class="text-end">
            <button
              type="button"
              class="btn btn-sm btn-primary me-1"
              title="View revision details"
              (click)="onOpen(revision)">
              <i class="fa fa-eye"></i>
            </button>
            @if (hasAttachment(revision)) {
              <button
                type="button"
                class="btn btn-sm btn-primary me-1"
                title="Download attachment"
                (click)="downloadAttachment(revision)">
                <i class="fa fa-download"></i>
              </button>
            }
            @if (canDelete) {
              <button
                type="button"
                class="btn btn-sm btn-danger"
                title="Delete revision"
                (click)="onDelete(revision)">
                <i class="fa fa-trash"></i>
              </button>
            }
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="7" class="text-center text-muted py-3">
            @if (isLoading) {
              Loading revisions...
            } @else {
              This document has no revision yet.
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
